import PropTypes from 'prop-types';
import React from 'react';
import { formatTelephone } from '../../../utils';

const PhoneLink = ({ number, children, ...props }) => (<a
  target="_blank"
  rel="noopener noreferrer"
  href={`tel:${number}`}
  {...props}
>{children || formatTelephone(number)}</a>);

PhoneLink.propTypes = {
  number: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default PhoneLink;



// WEBPACK FOOTER //
// ./client/app/shared/components/PhoneLink/index.jsx